import VueAxios from '@/api/VueAxios'
import SnackbarError from '@/components/snackbar/SnackbarError'

declare global {
    interface Window {
        $cookies: any;
    }
}

const EventType = {
    namespaced: true,
    state: {
        eventTypes: [],
    },
    mutations: {
        SET_LIST(state: any, payload: any) {
            EventType.state.eventTypes = payload
        }
    },
    actions: {
        async FETCH_LIST({commit, dispatch}: any) {
            try {
                const response = await VueAxios.get('/event-types')
                const list = response.data
                await commit('SET_LIST', list)
                return list
            } catch (err) {
                SnackbarError({commit, dispatch}, err)
                throw err
            }
        },
    },
    getters: {
        getEventTypes(state: any) {
            return EventType.state.eventTypes
        }
    },

}

export default EventType
